import { render, staticRenderFns } from "./teacherTraining.vue?vue&type=template&id=6e174b5a&scoped=true"
import script from "./teacherTraining.vue?vue&type=script&lang=js"
export * from "./teacherTraining.vue?vue&type=script&lang=js"
import style0 from "./teacherTraining.vue?vue&type=style&index=0&id=6e174b5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e174b5a",
  null
  
)

export default component.exports